import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiSetCexAutoTradeSwitch } from "@/api";
import type {
  SetCexAutoTradeSwitchRequest,
  SetCexAutoTradeSwitchResponse,
} from "@/api/types";

export function useSetCexAutoTradeSwitch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      data: SetCexAutoTradeSwitchRequest
    ): Promise<SetCexAutoTradeSwitchResponse> => {
      const res = await ApiSetCexAutoTradeSwitch(data);
      console.log("ApiSetCexAutoTradeSwitch", res);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cexAutoTradeUserSetting"] });
    },
  });
}
